// context
import { useModal } from "context/ModalContext/ModalContext"
import useAuthenticationContext from "context/Authentication/useAuthenticationContext"
import { MODALS } from "constants/modals"
// utils

const LicensePendingChecker = () => {
  const { openModal } = useModal()

  const { user } = useAuthenticationContext()

  if (!user?.id) {
    return null
  }

  if (user?.licensePendingApproval) {
    openModal(MODALS.AUTH.LICENSE_PENDING)
  }

  return null
}

export default LicensePendingChecker
